import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const Burger2Icon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4H15C15.55 4 16 3.55 16 3C16 2.45 15.55 2 15 2H1C0.45 2 0 2.45 0 3C0 3.55 0.45 4 1 4ZM15 12H1C0.45 12 0 12.45 0 13C0 13.55 0.45 14 1 14H15C15.55 14 16 13.55 16 13C16 12.45 15.55 12 15 12ZM15 7H1C0.45 7 0 7.45 0 8C0 8.55 0.45 9 1 9H15C15.55 9 16 8.55 16 8C16 7.45 15.55 7 15 7Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default Burger2Icon;
